import { render } from "./HeaderComponent.vue?vue&type=template&id=021b890c&scoped=true&ts=true&lang=pug"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderComponent.vue?vue&type=style&index=0&id=021b890c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021b890c"]])

export default __exports__